import camelcaseKeys from 'camelcase-keys';
import { useEffect, useState } from 'react';
import { getSpecialFunctionsDropdownService } from '../services';

const useGetUnitSpecialFunctions = (): { specialFunctions: any; isFetching: boolean } => {
  const [specialFunctions, setSpecialFunctions] = useState<any>([]);
  const [isFetching, setIsFetching] = useState<boolean>(true);
  useEffect(() => {
    setIsFetching(true);
    getSpecialFunctionsDropdownService(
      {},
      {
        successAction: (response) => {
          if (response?.success && response?.data && response?.data.length > 0) {
            const resultData = response.data.map((result) => camelcaseKeys(result));
            setSpecialFunctions(resultData);
          } else {
            setSpecialFunctions([]);
          }
          setIsFetching(false);
        },
        errorAction: (error) => {
          setSpecialFunctions([]);
          setIsFetching(false);
        }
      }
    );
  }, []);

  return { specialFunctions, isFetching };
};

export default useGetUnitSpecialFunctions;
